import { DatePicker } from 'antd';
import React from 'react';
const getDateType = (showTime) => {
    if (showTime === 1) {
        return 'year';
    }
    if (showTime === 2) {
        return 'month';
    }
    if (showTime === 3) {
        return 'date ';
    }
    return 'date';
},
 { RangePicker } = DatePicker,
    DateForm = (props) => {
        let { setting = {}, updated, desc } = props;
        const disabled = updated !== 0;
        let { type, showTime } = setting;
        if (type === 'range') {
            return <RangePicker picker={getDateType(showTime)} disabled={disabled} style={{ width: '100%' }} showTime={showTime === 4} />;
        }
        return (
            <DatePicker
                picker={getDateType(showTime)}
                disabled={disabled}
                style={{ width: '100%' }}
                showTime={showTime === 4}
                placeholder={desc}
            ></DatePicker>
        );
    };

export default DateForm;
